import { CloseIcon } from '@/ui/icons';
import rightArrowIcon from '@/public/images/icons/right-arrow.svg';
import { useLocalization } from '@/services/localizationService';

type Props = {
  onDismiss: () => void;
  onLogin: () => void;
};

export function CookieLoginCta({ onDismiss, onLogin }: Props) {
  const { t, data } = useLocalization();

  return (
    <aside
      aria-describedby="cookie-login-cta-description"
      aria-labelledby="cookie-login-cta-title"
      aria-live="polite"
      className="fixed z-30 bottom-5 end-5 w-[440px] max-w-[calc(100vw-2.5rem)] rounded-[20px] border border-[#E9E7EC] bg-white p-6 text-[#121216] shadow-[0_18px_60px_rgba(0,0,0,0.34)] 2xl:bottom-10 2xl:end-10 2xl:w-[480px] 2xl:max-w-[calc(100vw-5rem)] 2xl:rounded-[24px] 2xl:p-8"
      role="region"
    >
      <button
        aria-label={data.home.cookieLoginCtaDismiss}
        className="absolute top-3.5 end-3.5 grid h-8 w-8 place-items-center rounded-full bg-[#F3F1F5] text-[#555159] 2xl:top-5 2xl:end-5 2xl:h-10 2xl:w-10"
        onClick={onDismiss}
        type="button"
      >
        <CloseIcon aria-hidden className="h-[18px] w-[18px] 2xl:h-5 2xl:w-5" />
      </button>
      <p className="mb-2.5 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.1em] text-[#6B6670] 2xl:mb-3 2xl:gap-2 2xl:text-[12px]">
        <img
          alt=""
          aria-hidden
          className="h-3.5 w-3.5 rtl:scale-x-[-1] 2xl:h-4 2xl:w-4"
          src={rightArrowIcon.src}
        />
        {t(data.home.cookieLoginCtaEyebrow)}
      </p>
      <h2
        className="text-[28px] font-semibold leading-[1.16] tracking-[-0.7px] text-[#121216] 2xl:text-[34px]"
        id="cookie-login-cta-title"
      >
        {t(data.home.cookieLoginCtaTitle)}
      </h2>
      <p
        className="mt-2 max-w-xs text-[15px] leading-[1.45] text-[#66616B] 2xl:mt-3 2xl:max-w-sm 2xl:text-[17px]"
        id="cookie-login-cta-description"
      >
        {t(data.home.cookieLoginCtaDescription)}
      </p>
      <div className="mt-5 flex items-center gap-2 2xl:mt-6 2xl:gap-3">
        <button
          className="flex min-h-[48px] flex-1 items-center justify-center gap-2.5 rounded-full bg-[#121216] px-[18px] py-3 text-[15px] font-semibold text-white 2xl:min-h-[56px] 2xl:gap-3 2xl:px-6 2xl:text-[17px]"
          onClick={onLogin}
          type="button"
        >
          {t(data.header.logInSignUp)}
          <img
            alt=""
            aria-hidden
            className="h-3 w-[15px] brightness-0 invert rtl:scale-x-[-1] 2xl:h-3.5 2xl:w-[17px]"
            src={rightArrowIcon.src}
          />
        </button>
        <button
          className="min-h-[48px] px-[13px] py-3 text-[14px] font-semibold text-[#625D66] 2xl:min-h-[56px] 2xl:px-4 2xl:text-[16px]"
          onClick={onDismiss}
          type="button"
        >
          {t(data.account.notNow)}
        </button>
      </div>
    </aside>
  );
}
